var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", { staticClass: "w-full" }, [
      _vm._v(_vm._s(_vm._f("nullable")(_vm.category.name))),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "w-full" }, [
      _vm._v(
        _vm._s(
          _vm._f("sentenceCase")(
            _vm.category.currency ? _vm.category.currency : "None"
          )
        )
      ),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "w-full" }, [
      _vm._v(_vm._s(_vm.category.hide_budget)),
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "edit-button",
          on: {
            click: function ($event) {
              return _vm.$emit("edit", _vm.category.id)
            },
          },
        },
        [_c("i", { staticClass: "fa fa-fw fa-pencil-square-o" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }